import * as React from 'react';
import { CategoryData } from '../App';
import { CategoryHeader } from '../components/CategoryHeader';
import { CategorySidebar } from '../components/CategorySidebar';
import { CategoryPulldown } from '../components/CategoryPulldown';
import * as styles from '../css/CategoryPage.less';
import { PreziCard } from './PreziCard/PreziCard';
import { CATEGORY_ALL_SLUG, PreziData } from './App';
import { WebsiteLogger } from '@prezi/client-logger-module';
import { MetaTags } from '../components/Meta';

declare const Site: any;

document.body.style.backgroundColor = '#152235';

export interface CategoryPageProps {
    currentCategory: CategoryData;
    categories: Array<CategoryData>;
    prezis: Array<PreziData>;
    basePath: string;
    categoryString: string;
}

export default class CategoryPage extends React.Component<CategoryPageProps, any> {
    constructor(props: CategoryPageProps) {
        super(props);
    }

    getCanonicalUrl(): string {
        const slug = this.props.currentCategory.slug;
        return slug === CATEGORY_ALL_SLUG ? this.props.basePath : `${this.props.basePath}${slug}/`;
    }

    getRelatedPrezis(prezis: Array<PreziData>, currentCategory: CategoryData): Array<PreziData> {
        return prezis.filter(prezi =>
            prezi.categories.indexOf(currentCategory.slug) !== -1,
        );
    }

    logCategoryView = function() {
        WebsiteLogger.log({
            action: 'view',
            object: 'logged_element',
            trigger: 'view',
            payload: {element_text: this.props.currentCategory.slug,
                element_type: 'gallery_category_page',
                source_url: window.location.pathname,
                user_id: Site.user_id},
        });
    };

    componentDidMount() {
        this.logCategoryView();
    }

    componentDidUpdate() {
        this.logCategoryView();
    }

    render() {
        return (
            <div>
                <MetaTags
                    title={ this.props.currentCategory.page_title }
                    description={ this.props.currentCategory.meta_description }
                    slug={ this.props.currentCategory.slug }
                    canonicalUrl={ this.getCanonicalUrl() }
                />
                <CategoryHeader category={ this.props.currentCategory } />
                <div className={ 'section ' + styles.category }>
                    <div className={ 'container' }>
                        <div className={ 'row' }>
                            <div className={ 'col-lg-2 visible-lg' }>
                                <CategorySidebar
                                    categories={ this.props.categories }
                                    basePath={ this.props.basePath }
                                    currentCategory={ this.props.currentCategory }
                                    categoryString={ this.props.categoryString }
                                />
                            </div>
                            <div className={ 'container visible-md visible-sm visible-xs' }>
                                <CategoryPulldown
                                    categories={ this.props.categories }
                                    basePath={ this.props.basePath }
                                    currentCategory={ this.props.currentCategory }
                                />
                            </div>
                            <div className={ 'col-xs-12 col-lg-10 pad-zero' }>
                                { this.getRelatedPrezis(this.props.prezis, this.props.currentCategory).map(prezi => (
                                    <PreziCard key={ prezi.oid } prezi={ prezi } />
                                )) }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./assets/js/GalleryPage/CategoryPage2.tsx